import * as React from "react";

import logo from '../images/shaq.jpg';

export function ErrorPage(): JSX.Element {
    return (
        <div style={{ textAlign: "center" }}>
            <img src={logo} className="App-logo" alt="shaq" />
            <div style={{ marginTop: "50px" }}>THIS ERROR PAGE IS SHAQTAQULAR</div>
        </div>
    );
}